import { Injectable } from '@angular/core';
import { PromptService } from 'src/app/project/components/prompt/prompt.service';
import { ERowType } from 'src/app/project/shared/enums/row-type.enum';
import { CustomTableService } from './custom-table.service';
import { TTableItem } from './table.model';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import { asyncScheduler, BehaviorSubject } from 'rxjs';
import { observeOn } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TableLoadingService {
  constructor(
    private customTableService: CustomTableService,
    private promptService: PromptService,
    private translationPipe: TranslationPipe,
  ) {}

  private isTableLoadingSubject = new BehaviorSubject<boolean>(false);
  isTableLoading$ = this.isTableLoadingSubject.pipe(observeOn(asyncScheduler));

  toggleSpinner(show: boolean, isLoadMore?: boolean): void {
    if (isLoadMore) {
      const table = this.customTableService.getTable();

      if (show) {
        const alreadyLoading = table.items.find((item) => item.type === ERowType.LOADING);

        if (!alreadyLoading) {
          const loadingItem: TTableItem = { type: ERowType.LOADING };
          table.items.push(loadingItem);
        }
      } else {
        table.items = table.items.filter((item) => item.type !== ERowType.LOADING);
      }

      table.tableBody.load(true);
    } else {
      this.isTableLoadingSubject.next(show);
    }
  }

  showLoadingPointsError(): void {
    const promptMessage = this.translationPipe.transform('prompt_table_load_error');
    this.promptService.showError(promptMessage);
  }
}
